export const sideDrawerConstants = {
    OPEN: 'OPEN_SIDE_DRAWER',
    CLOSE: 'CLOSE_SIDE_DRAWER'
};
